module.exports = __webpack_public_path__ + "static/media/apple-touch-icon-152x152.236ea1b1.png";